'use strict';

require('core-js/fn/object/assign');

require('babel-polyfill');

var _colors = require('styles/_colors.scss');

var _colors2 = _interopRequireDefault(_colors);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _ravenJs = require('raven-js');

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _App = require('./v2/App');

var _App2 = _interopRequireDefault(_App);

var _configureStore = require('./v2/store/configureStore');

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_ravenJs2.default.config(_config2.default.sentry).install();

function getPortal() {
  switch (location.hostname) {
    case 'dev-forms.rimiinsurance.com':
    case 'forms.rimiinsurance.com':
      return 'rimi';
    case 'dev-forms.msg-insurance.com':
    case 'forms.msg-insurance.com':
      return 'msg';
    case 'dev-forms.2visitcanada-insurance.com':
    case 'forms.2visitcanada-insurance.com':
      return 'visitcanada';
    case 'dev-insurecanada.policy-forms.com':
    case 'insurecanada.policy-forms.com':
      return 'insurecanada';
    default:
      return 'ingle';
  }
}

function getColour(type) {
  return _colors2.default['' + getPortal() + type];
}

function setDomainColour(type) {
  var root = document.documentElement;
  root.style.setProperty('--client-' + type, getColour(type));
}

function setDomainColors(type) {
  setDomainColour(type);
}

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: (0, _configureStore2.default)() },
  _react2.default.createElement(_App2.default, null)
), document.getElementById('app'), setDomainColors('primary'), setDomainColors('secondary'));


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0